import React from 'react'

function UserForm({ modalData, setModalData, isEditing, enableEditMode, saveChanges, closeModal }) {
  return (
    <>
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
            <div className="bg-white shadow-lg mx-6 p-6 rounded-lg w-auto">
                <h2 className="mb-4 font-semibold text-lg">
                    {isEditing ? "Edit Product" : "View Product"}
                </h2>

                {modalData && (
                    <>
                        {isEditing ? (
                            // Mode édition
                            <form>
                                <div className="mb-4">
                                    <label className="block text-gray-700">Name</label>
                                    <input
                                        type="text"
                                        value={modalData.name}
                                        onChange={(e) =>
                                            setModalData({ ...modalData, name: e.target.value })
                                        }
                                        className="border-gray-300 px-3 py-2 border rounded w-full"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700">Email</label>
                                    <input
                                        type="email"
                                        value={modalData.email}
                                        onChange={(e) =>
                                            setModalData({ ...modalData, email: e.target.value })
                                        }
                                        className="border-gray-300 px-3 py-2 border rounded w-full"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700">Product</label>
                                    <input
                                        type="text"
                                        value={modalData.product}
                                        onChange={(e) =>
                                            setModalData({ ...modalData, product: e.target.value })
                                        }
                                        className="border-gray-300 px-3 py-2 border rounded w-full"
                                    />
                                </div>
                            </form>
                        ) : (
                            // Mode vue
                            <div>
                                <p>
                                    <strong>Name:</strong> {modalData.name}
                                </p>
                                <p>
                                    <strong>Email:</strong> {modalData.email}
                                </p>
                                <p>
                                    <strong>Product:</strong> {modalData.product}
                                </p>
                            </div>
                        )}
                    </>
                )}

                {/* Boutons */}
                <div className="relative flex justify-between space-x-4 mt-4 w-full">
                    {!isEditing ? (
                        <>
                            <button
                                type="button"
                                className="bg-gray-300 hover:bg-gray-400 px-4 py-1 rounded text-gray-700"
                                onClick={closeModal}
                            >
                                Fermer
                            </button>
                            <button
                                type="button"
                                className="bg-blue-500 hover:bg-blue-600 px-4 py-1 rounded text-white"
                                onClick={enableEditMode}
                            >
                                Modifier
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="bg-gray-300 hover:bg-gray-400 px-4 py-1 rounded text-gray-700"
                                onClick={closeModal}
                            >
                                Annuler
                            </button>
                            <button
                                type="button"
                                className="bg-green-500 hover:bg-green-600 px-4 py-1 rounded text-white"
                                onClick={saveChanges}
                            >
                                Enregistrer
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    </>
  )
}

export default UserForm